import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        const response = await axios.get(`${BACKEND_URL}/api/contact`);
        setMessages(response.data);
      } catch (error) {
        console.error("Error fetching messages:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  return (
    <div className="bg-[#1a1c1b] min-h-screen text-white flex flex-col">
      <Navbar />
      <div className="flex-grow pt-32 pb-20 px-6">
        <div className="container-custom mx-auto max-w-6xl">
          <h1 className="heading-2 mb-8 text-[var(--brand-primary)]">Inquiries</h1>
          
          {loading ? (
            <div className="flex justify-center py-20">
              <Loader2 className="w-10 h-10 animate-spin text-[var(--brand-primary)]" />
            </div>
          ) : messages.length === 0 ? (
            <div className="text-center py-20 bg-[#302f2c] rounded-2xl border border-[var(--border-medium)]">
              <p className="body-large text-gray-400">No inquiries yet.</p>
            </div>
          ) : (
            <div className="overflow-x-auto bg-[#302f2c] rounded-2xl border border-[var(--border-medium)]">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="border-b border-[var(--border-medium)]">
                    <th className="p-6 text-sm font-bold uppercase tracking-wider text-[var(--brand-primary)]">Date</th>
                    <th className="p-6 text-sm font-bold uppercase tracking-wider text-[var(--brand-primary)]">Name</th>
                    <th className="p-6 text-sm font-bold uppercase tracking-wider text-[var(--brand-primary)]">Email</th>
                    <th className="p-6 text-sm font-bold uppercase tracking-wider text-[var(--brand-primary)]">Subject</th>
                    <th className="p-6 text-sm font-bold uppercase tracking-wider text-[var(--brand-primary)]">Message</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[var(--border-medium)]">
                  {messages.map((msg) => (
                    <tr key={msg.id} className="hover:bg-white/5 transition-colors">
                      <td className="p-6 text-sm text-gray-400 whitespace-nowrap">
                        {new Date(msg.timestamp).toLocaleDateString()} <br/>
                        <span className="text-xs opacity-70">{new Date(msg.timestamp).toLocaleTimeString()}</span>
                      </td>
                      <td className="p-6 font-medium">{msg.name}</td>
                      <td className="p-6 text-gray-300">{msg.email}</td>
                      <td className="p-6">
                        <span className="bg-[var(--secondary-olive)] text-[var(--brand-primary)] text-xs px-2 py-1 rounded-full uppercase tracking-wide">
                          {msg.subject}
                        </span>
                      </td>
                      <td className="p-6 text-gray-300 min-w-[300px]">{msg.message}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminMessages;
